import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { ProfileWithMetadata } from '@src/types/api/models';

export const useMandatoryInfoRedirect = (profileWithMetadata?: ProfileWithMetadata | null) => {
  const router = useRouter();

  useEffect(() => {
    if (router.pathname.startsWith('/profile/complete-profile')) {
      return;
    }

    if (profileWithMetadata?.isMandatoryInfoComplete === false) {
      router.push({
        pathname: '/profile/complete-profile',
        query: { from: window.location.href },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileWithMetadata]);
};
